<!-- Predefined Category -->
<div *ngIf="!otherCategory?.status" class="border p-4 rounded card">
  <div class="mb-5 card-head">
    <h4 class="text-gray-700">Craft Your Recipe</h4>
    <div class="mb-2 text-muted fw-semibold">
      Select up to three specific contexts to <strong>Curate Your Blend of Contexts</strong>, serving as the foundation for our AI to generate personalized ideas tailored to your needs.
    </div>
  </div>
  <div class="card-body card-scroll mh-300px p-0" *ngIf="categories.length">
    <span
      (click)="toggleCategory(category)"
      *ngFor="let category of categories"
      [ngClass]="{
        'badge-light': !category?.selected && selectedCategories.length >= maximumCategories,
        'badge-light-primary': !category?.selected && selectedCategories.length < maximumCategories,
        'badge-primary': !!category?.selected
      }"
      class="badge badge-lg fake-link me-2 mb-2"
    >
      {{ category.label }}
    </span>
    <span (click)="chooseOther()" class="d-block btn btn-light mt-4">Something Else</span>
  </div>
</div>
<!-- Predefined Category -->

<!-- Custom Category -->
<ng-container *ngIf="!!otherCategory?.status">
  <div class="border p-4 rounded card">
    <div class="mb-5 card-head">
      <h4 class="text-gray-700">
        <button (click)="disableOther()" class="btn btn-light btn-icon btn-sm me-2">
          <i class="ki-duotone ki-arrow-left fs-2">
            <span class="path1"></span>
          <span class="path2"></span>
          </i>
          <!-- <svg-icon src="assets/images/svg/system/wizard-step-arrow-previous.svg?rand=1.2" class="svg-icon svg-icon-2"></svg-icon> -->
        </button>
        Customize Your Recipe
      </h4>
    </div>
    <div class="card-body p-0">
      <input
        [(ngModel)]="otherCategory.value"
        (ngModelChange)="onUpdateCustomCategory($event)"
        placeholder="Enter the category(s) of the idea you want"
        class="form-control"
      />
    </div>
  </div>
</ng-container>
<!-- Custom Category -->